import { writable } from 'svelte/store';

function createStore() {
    const { subscribe, update } = writable({
        hasNextPage: false,
        isLoadingNextPage: false,
    });

    function setHasNextPage(hasNextPage: boolean) {
        update((currentPageState) => ({
            ...currentPageState,
            hasNextPage,
        }));
    }

    function setLoadingNextPage(isLoadingNextPage: boolean) {
        update((currentPageState) => ({
            ...currentPageState,
            isLoadingNextPage,
        }));
    }

    return { subscribe, setHasNextPage, setLoadingNextPage };
}

export const paginationStore = createStore();
export type PaginationStore = typeof paginationStore;
